import { CONTACT } from "./data";

export const Footer = () => (
  <footer className="relative bg-ink text-bone pt-20 md:pt-24 pb-10 overflow-hidden" data-testid="footer">
    <div className="noise-overlay" />
    <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-bone/15 pt-10 text-sm">
        <div>
          <p className="text-bone/45 mb-3 tracking-[0.15em] uppercase text-xs">Email</p>
          <a href={`mailto:${CONTACT.email}`} className="hover:text-terra transition-colors" data-testid="footer-email">{CONTACT.email}</a>
        </div>
        <div>
          <p className="text-bone/45 mb-3 tracking-[0.15em] uppercase text-xs">Phone</p>
          <a href={`tel:${CONTACT.phoneHref}`} className="hover:text-terra transition-colors" data-testid="footer-phone">{CONTACT.phone}</a>
        </div>
        <div>
          <p className="text-bone/45 mb-3 tracking-[0.15em] uppercase text-xs">Services</p>
          <p className="text-bone/80">Teaching · Inclusion · Wellbeing</p>
        </div>
        <div>
          <p className="text-bone/45 mb-3 tracking-[0.15em] uppercase text-xs">Tagline</p>
          <p className="text-bone/80 font-serif italic text-base">Potential beyond challenges, always.</p>
        </div>
      </div>

      <div className="mt-14 flex flex-col md:flex-row md:items-center md:justify-between gap-4 border-t border-bone/15 pt-6 text-xs text-bone/45">
        <p>© {new Date().getFullYear()} The People's Josh. All rights reserved.</p>
        <div className="flex items-center gap-5">
          <a href="/dashboard" data-testid="footer-team-login" className="hover:text-terra transition-colors">Team login</a>
          <span className="font-serif text-lg text-bone">The People's <span className="italic text-terra">Josh</span></span>
        </div>
      </div>
    </div>
  </footer>
);
